export function Spinner() {
  return (
    <div className="flex justify-center py-16">
      <div className="animate-spin h-6 w-6 border-2 border-accent border-t-transparent rounded-full" />
    </div>
  )
}
